module.exports = __webpack_public_path__ + "img/botnoi.b79285ee.png";